import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { queryByMid } from '@/api/dashboard/material';
import { queryReport } from '@/api/dashboard/report';
import { format, addDays } from 'date-fns';
import Pagination from '@/components/Pagination';
import { EngineType } from '@com/config/engine-type';

export default {
  components: { Pagination: Pagination },
  filters: {
    midSource: function midSource(v) {
      switch (v) {
        case 1:
          return '测试任务发布';
        case 2:
          return '定制模板在线制作（Playturbo制作）';
        case 4:
          return '通用模板在线制作';
        case 5:
          return '定制模板在线制作（后台制作）';
        case 6:
          return '补dsp素材';
        case 7:
          return 'PlaySmart在线制作';
        case 99:
          return '修复素材域名写死重新打包';
        default:
          return '未知历史数据';
      }
    },
    materialSource: function materialSource(v) {
      switch (v) {
        case 1:
          return '广告主提供';
        case 2:
          return '内部制作';
        case 3:
          return '广告主提供（SS送审）';
        default:
          return '未知';
      }
    },
    categoryName: function categoryName(v) {
      switch (v) {
        case 1:
          return '动态endcard';
        case 2:
          return 'playable 2d';
        case 3:
          return 'playable 3d';
        case 4:
          return '交互视频';
        case 5:
          return '全景';
        default:
          return v;
      }
    },
    engineType: function engineType(v) {
      var temp = EngineType.find(function (item) {
        return item.value === v;
      });
      if (temp) {
        return temp.label;
      }
      return v;
    }
  },
  mounted: function mounted() {
    if (this.$route.query) {
      this.query = _.cloneDeep(this.$route.query);
    }
    this.fetchData();
  },

  computed: {
    offersPageData: function offersPageData() {
      if (!this.offers.list) {
        return null;
      }
      var offset = (this.offers.page - 1) * this.offers.page_size;
      return _.slice(this.offers.list, offset, offset + this.offers.page_size);
    }
  },
  data: function data() {
    return {
      query: {
        mid: ''
      },
      loading: {
        info: false,
        offers: false,
        report: false
      },
      info: null,
      offers: {
        total: 0,
        page: 1,
        page_size: 20,
        list: null
      },
      report: null,
      releaseHistory: null
    };
  },


  watch: {
    $route: function $route(to, from) {
      this.query = _extends({}, this.query, to.query);
      this.fetchData();
    }
  },

  methods: {
    handleQuery: function handleQuery() {
      if (!this.query.mid) {
        this.$message.error('请输入mid');
        return;
      }
      this.$router.push({
        name: this.$route.name,
        query: _.cloneDeep(this.query)
      });
    },
    updateOfferListPage: function updateOfferListPage(page) {
      this.offers.page = page;
    },
    updateOfferListPageSize: function updateOfferListPageSize(size) {
      this.offers.page_size = size;
    },
    fetchData: function fetchData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var resp, resp2;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.query.mid) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _this.loading.info = true;
                _this.loading.offers = true;
                _this.loading.report = true;
                _context.prev = 5;
                _context.next = 8;
                return queryByMid(_this.query.mid);

              case 8:
                resp = _context.sent;

                _this.info = _.get(resp, 'data.data.publish_info');
                _this.info.publish_time = format(new Date(_this.info.publish_time * 1000), 'YYYY-MM-DD HH:mm:ss');
                _this.loading.info = false;
                _this.offers.page = 1;
                _this.offers.page_size = 20;
                _this.offers.list = (_.get(resp, 'data.data.offers') || []).map(function (item) {
                  item.ctime = format(new Date(item.ctime * 1000), 'YYYY-MM-DD HH:mm:ss');
                  return item;
                });
                _this.offers.total = _this.offers.list.length;
                _this.loading.offers = false;
                _this.releaseHistory = (_.get(resp, 'data.data.release_history') || []).map(function (item) {
                  item.publish_time = format(new Date(item.publish_time * 1000), 'YYYY-MM-DD HH:mm:ss');
                  return item;
                });
                _context.next = 20;
                return queryReport({
                  mids: resp.data.data.mid,
                  sdate: format(addDays(new Date(), -31), 'YYYYMMDD'),
                  edate: format(addDays(new Date(), -1), 'YYYYMMDD'),
                  period: 'day',
                  page_size: 30
                });

              case 20:
                resp2 = _context.sent;

                _this.report = (_.get(resp2, 'data.data.list') || []).map(function (item) {
                  item = _extends({}, item, {
                    ctr: item.impression > 0 ? (item.click / item.impression * 100).toFixed(2) + '%' : '-',
                    cvr: item.click > 0 ? (item.install / item.click * 100).toFixed(2) + '%' : '-',
                    ivr: item.impression > 0 ? (item.install / item.impression * 100).toFixed(2) + '%' : '-',
                    ecpm: item.impression > 0 ? '' + (item.revenue / item.impression).toFixed(2) : '0'
                  });
                  item.revenue = (item.revenue / 1000).toFixed(2);
                  return item;
                });
                _this.loading.report = false;
                _context.next = 28;
                break;

              case 25:
                _context.prev = 25;
                _context.t0 = _context['catch'](5);

                console.log(_context.t0);

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[5, 25]]);
      }))();
    }
  }
};